import React from 'react';
import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import { proposalTokens } from './tokens';

interface DetailBoxProps {
  icon: LucideIcon;
  label: string;
  value: string;
}

/**
 * DetailBox component for displaying key-value information
 * Used in the proposal cover page
 */
export function DetailBox({ icon: Icon, label, value }: DetailBoxProps) {
  return (
    <div 
      className={cn(
        "flex flex-col items-center justify-center p-3 sm:p-6 w-full",
        "bg-white/5 border border-white/10 rounded-xl backdrop-blur-md",
        "hover:bg-white/10 transition-colors group"
      )}
      style={{ fontFamily: proposalTokens.typography.fontFamily.sans.join(', ') }}
    >
      <Icon className={cn(
        "hidden sm:block w-6 h-6 sm:w-8 sm:h-8 mb-2 sm:mb-3",
        "group-hover:scale-110 transition-transform"
      )} 
      style={{ color: proposalTokens.colors.gold }}
      />
      <span className="text-white/60 text-xs sm:text-sm uppercase tracking-wider mb-1 text-center">
        {label}
      </span>
      <span className="text-white font-semibold text-sm sm:text-lg text-center">
        {value}
      </span>
    </div>
  );
}

